import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=c7b8b872&"
import script from "./ContextMenu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ContextMenu.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=c7b8b872&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports